import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    marginTop: 5,
  },
  messageText: {
    textAlign: 'left',
    marginBottom: 10,
  },
  orderBox: {
    // borderWidth: 1,
    // borderRadius: 5,
    overflow: 'hidden',
    marginLeft: -14,
    marginRight: -15,
  },
  skeletonBox: {
    height: 500,
    borderRadius: 5,
  },
  hboxWrapper: {
    marginTop: 10,
    justifyContent: 'flex-start',
    gap: 10,
  },
  driverNameText: {
    marginBottom: 5,
    textAlign: 'left',
  },
  driverSubText: {},
  contactText: {
    textAlign: 'left',
  },
  etaContainer: {
    marginTop: 10,
    marginHorizontal: -15,
    marginBottom: -15,
    borderBottomWidth: 2,
    borderRightWidth: 2,
    borderLeftWidth: 2,
    borderBottomRightRadius: 7,
    borderBottomLeftRadius: 7,
    paddingTop: 10,
  },
  etaHBox: {
    paddingHorizontal: 10,
    paddingBottom: 10,
  },
  iFrameContainer: {
    marginLeft: -2,
    marginTop: -5,
    flex: 1,
  },
  iFrameContainerBeforeInTransit: {
    position: 'absolute',
    top: -132,
    height: 633,
  },
  textFlex: {flex: 1},
  delayedText: {textAlign: 'left', paddingHorizontal: 15},
  textStyle: {textAlign: 'left'},
  vendorCard: {
    borderWidth: 1,
    borderRadius: 12,
    overflow: 'hidden',
  },
  vendorHeaderRow: {
    justifyContent: 'flex-start',
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 14,
  },
  vendorBadge: {
    paddingHorizontal: 12,
    paddingVertical: 5,
    borderRadius: 20,
  },
  vendorBadgeText: {
    fontSize: 12,
  },
  driverRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingBottom: 16,
    marginTop: 15,
  },
  driverInfoRow: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
    flex: 1,
  },
  driverAvatar: {
    width: 42,
    height: 42,
    borderRadius: 21,
    alignItems: 'center',
    justifyContent: 'center',
  },
  driverAvatarText: {
    fontSize: 16,
  },
  driverTextColumn: {
    justifyContent: 'flex-start',
  },
  driverNameTextNew: {
    textAlign: 'left',
    marginBottom: 3,
  },
  driverPhoneTextNew: {
    textAlign: 'left',
    fontSize: 12,
  },
  callButton: {
    width: 38,
    height: 38,
    borderRadius: 19,
    alignItems: 'center',
    justifyContent: 'center',
  },
  deliveryInstructionsContainer: {
    borderTopWidth: 1,
    paddingHorizontal: 16,
    paddingTop: 14,
    paddingBottom: 16,
  },
  deliveryInstructionsHeader: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 6,
    marginBottom: 6,
  },
  deliveryInstructionsLabel: {
    fontSize: 12,
  },
  deliveryInstructionsText: {
    textAlign: 'left',
  },
});
